export default "__VITE_ASSET__27860cb6__"